import React from "react";

interface OverlayTextProps {
  text?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function OverlayText({
  text = "OVERLAY",
  className = "",
  style = {},
}: OverlayTextProps) {
  const lines = text.split("\n");

  // pointer-events-none
  return (
    <div className={`${className}`} style={style}>
      <h1
        className="text-[26px] md:text-[28px] lg:text-[30px] uppercase font-superior leading-tight tracking-tight text-black w-full"
        style={{ color: "#000000" }}
      >
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </h1>
    </div>
  );
}
